import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { Card, Divider } from "@material-ui/core";
import { CardActionArea } from "@material-ui/core";
import { CardActions } from "@material-ui/core";
import { CardContent } from "@material-ui/core";
import { CardMedia } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { Typography } from "@material-ui/core";

import { Modal } from "@material-ui/core";
import { Box } from "@material-ui/core";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import { makeStyles } from "@material-ui/core/styles";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { ArrowLeftOutlined } from "@material-ui/icons";
import { getAllBlogs } from "../../_redux/homepageCrud";
import { actions } from "../../_redux/homepageRedux";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import mag2 from "../../../../../ebusHomePics/2mag.jpg";
import { useMediaQuery } from "react-responsive";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(21),
    fontWeight: theme.typography.fontWeightRegular,
    // fontSize:theme.typography.fontSize=17,
  },
  des: {
    fontSize: theme.typography.pxToRem(18),
    lineHeight: "2",
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  typography: {
    padding: theme.spacing(2),
  },
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "blanchedalmond",
  border: "none",
  borderRadius: "15px",
  boxShadow: 24,
  p: 5,
};

function Sliderr(props) {
  const [open, setOpen] = useState(false);

  const { state } = useSelector(
    (state) => ({
      state: state.homepage,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  React.useEffect(() => {
    getAllBlogs().then((res) => {
      dispatch(actions.setBlogs(res.data.data));
    });
  }, []);

  const isTabletOrMobile = useMediaQuery({ maxWidth: 991 });

  const handleClick = () => {
    setOpen(true);
  };

  const classNamees = useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  const settings = {
    arrows: true,
    dots: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      {state.blogs && (
        <Slider
          {...settings}
          style={{ width: "100%", gap: "10px" }}
          className="mx-auto w-100 m-10"
        >
          <div className="d-flex card-group w-100 p-2" style={{ gap: "10px" }}>
            <a
              className="card custom-cards p-3"
              href={state?.blogs[0]?.link}
              target="_blank"
              style={{ borderRadius: "15px" }}
            >
              <div style={{ height: "20rem" }} className="w-100 p-3">
                <img
                  className="card-img-top objfit"
                  src={`https://ebus.ir/service/${state?.blogs[0]?.path}`}
                  alt={state.blogs[0] ? state?.blogs[0]?.alt : null}
                  width="100%"
                  height="100%"
                />
              </div>
              <div className="card-body">
                <h3 className="card-title">
                  {state.blogs[0] ? state?.blogs[0]?.title : null}
                </h3>
                {/* <p className="text-dark">
                  {state.blogs[0] ? state?.blogs[0]?.description : null}
                </p> */}
                <p className="text-dark"></p>
              </div>
            </a>
          </div>
          <div className="d-flex card-group w-100 p-2" style={{ gap: "10px" }}>
            <a
              className="card custom-cards p-3"
              href={state?.blogs[1]?.link}
              target="_blank"
              style={{ borderRadius: "15px" }}
            >
              <div style={{ height: "20rem" }} className="w-100 p-3">
                <img
                  className="card-img-top objfit"
                  src={`https://ebus.ir/service/${state.blogs[1]?.path}`}
                  alt={state.blogs[1] ? state?.blogs[1]?.alt : null}
                  width="100%"
                  height="100%"
                />
              </div>
              <div className="card-body">
                <h3 className="card-title">
                  {state.blogs[1] ? state?.blogs[1]?.title : null}
                </h3>
                {/* <p className="text-dark">
                  {state.blogs[1] ? state?.blogs[1]?.description : null}
                </p> */}
                <p className="text-dark"></p>
              </div>
            </a>
          </div>
          {/* </div> */}
          <div className="d-flex card-group w-100 p-2" style={{ gap: "10px" }}>
            <a
              className="card custom-cards p-3"
              href={state?.blogs[2]?.link}
              target="_blank"
              style={{ borderRadius: "15px" }}
            >
              <div style={{ height: "20rem" }} className="w-100 p-3">
                <img
                  className="card-img-top objfit"
                  src={`https://ebus.ir/service/${state?.blogs[2]?.path}`}
                  alt={state.blogs[2] ? state?.blogs[2]?.alt : null}
                  width="100%"
                  height="100%"
                />
              </div>
              <div className="card-body">
                <h3 className="card-title">
                  {state.blogs[2] ? state?.blogs[2]?.title : null}
                </h3>
                {/* <p className="text-dark">
                  {state.blogs[2] ? state?.blogs[2]?.description : null}
                </p> */}
                <p className="text-dark"></p>
              </div>
            </a>
          </div>
          <div className="d-flex card-group w-100 p-2" style={{ gap: "10px" }}>
            <a
              className="card custom-cards p-3"
              onClick={() => window.open(state?.blogs[3]?.link, "_blank")}
              style={{ borderRadius: "15px" }}
            >
              <div style={{ height: "20rem" }} className="w-100 p-3">
                <img
                  className="card-img-top objfit"
                  src={`https://ebus.ir/service/${state.blogs[3]?.path}`}
                  alt={state.blogs[3] ? state?.blogs[3]?.alt : null}
                  width="100%"
                  height="100%"
                />
              </div>
              <div className="card-body">
                <h3 className="card-title">
                  {state.blogs[3] ? state?.blogs[3]?.title : null}
                </h3>
                {/* <p className="text-dark">
                  {state.blogs[3] ? state?.blogs[3]?.description : null}
                </p> */}
                <p className="text-dark"></p>
              </div>
            </a>
          </div>
        </Slider>
      )}
    </>
  );
}

export default Sliderr;
